import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';
import Image from '../AppImage';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'Core Data Services', path: '/services-overview-interactive-capability-showcase' },
        { name: 'Fractional CDO', path: '/fractional-cdo-services-executive-leadership-solutions' },
        { name: 'AI Solutions', path: '/ai-solutions-intelligent-data-strategy-services' },
        { name: 'Data Maturity Assessment', path: '/data-maturity-calculator-lead-generation-assessment' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Knowledge Hub', path: '/knowledge-hub-thought-leadership-center' },
        { name: 'ROI Calculator', path: '/roi-calculator-suite-value-demonstration-tools' },
        { name: 'Newsletter', path: '/newsletter-subscription-lead-nurture-center-gdpr-compliant-email-marketing-hub' },
        { name: 'FAQ', path: '/frequently-asked-questions-comprehensive-faq-center' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about-expertise-trust-building' },
        { name: 'Contact', path: '/contact-multi-channel-engagement-hub' },
        { name: 'Book Consultation', path: '/contact-multi-channel-engagement-hub' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', path: '/privacy-policy-cookie-consent-management-gdpr-compliance-center' },
        { name: 'GDPR Compliance', path: '/privacy-policy-cookie-consent-management-gdpr-compliance-center' }
      ]
    }
  ];

  const socialLinks = [
    { name: 'LinkedIn', icon: 'Linkedin', url: 'https://linkedin.com/company/northstar-analytics' },
    { name: 'YouTube', icon: 'Youtube', url: 'https://youtube.com/northstaranalytics' }
  ];

  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            {/* Brand Section */}
            <div className="lg:col-span-4">
              <Link to="/" className="flex items-center space-x-3 mb-6">
                <div className="h-12 w-12">
                  <Image
                    src="/assets/images/northstar-icon-teal-1024-1771163020674.png"
                    alt="Northstar Analytics Logo"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-2xl font-bold tracking-tight">Northstar</span>
                  <span className="text-sm text-white/80 font-medium -mt-1">Analytics</span>
                </div>
              </Link>
              
              <p className="text-white/80 mb-6 leading-relaxed">
                Your trusted guide through the complex world of data strategy. We help organizations 
                transform data chaos into strategic clarity with expert consulting and practical frameworks.
              </p>
              
              <div className="flex items-center space-x-4">
                {socialLinks?.map((social) => (
                  <a
                    key={social?.name}
                    href={social?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors duration-300"
                    aria-label={social?.name}
                  >
                    <Icon name={social?.icon} size={18} />
                  </a>
                ))}
              </div>
            </div>

            {/* Footer Links */}
            <div className="lg:col-span-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                {footerSections?.map((section) => (
                  <div key={section?.title}>
                    <h3 className="font-semibold text-white mb-4">{section?.title}</h3>
                    <ul className="space-y-3">
                      {section?.links?.map((link) => (
                        <li key={link?.name}>
                          <Link
                            to={link?.path}
                            className="text-white/70 hover:text-secondary transition-colors duration-300 text-sm"
                          >
                            {link?.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/70 text-sm">
              © {currentYear} Northstar Analytics. All rights reserved.
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-white/70">
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} />
                <span>Dublin, Ireland</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={16} />
                <span>GDPR Compliant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;